import { useQuery as useQueryParams } from '@kiper/hooks';
import { PersonalizedInviteProvider } from '../../../../../store/PersonalizedInvite';
import FacialRegistrationComponent from './FacialRegistration';
import {
  adaptInviteGuestToPersonalizedInvite,
  isInviteExpired,
  isInviteValid,
} from '../../adapters/inviteGuestAdapter';
import LoadingPage from '../../../../../components/LoadingPage';
import { useFetchInviteGuest } from '../../../InviteGuest/hooks';
import InviteError, {
  InviteErrorTypes,
} from '../../../../../components/InviteError';

const FacialRegistrationContainer = () => {
  const querystring = useQueryParams();
  const guestHash = querystring?.get('q')?.replace(/ /g, '+') || '';

  const { data: queryData, loading, error } = useFetchInviteGuest({
    guestHash,
  });
  const inviteGuestData = queryData?.getInviteGuest;

  if (loading || !guestHash) {
    return <LoadingPage />;
  }

  if (error) {
    return <InviteError type={InviteErrorTypes.INVALID} />;
  }

  if (!isInviteValid(inviteGuestData)) {
    return <InviteError type={InviteErrorTypes.NOT_FOUND} />;
  }

  if (isInviteExpired(inviteGuestData)) {
    return <InviteError type={InviteErrorTypes.EXPIRED} />;
  }

  const adaptedData = adaptInviteGuestToPersonalizedInvite(inviteGuestData);

  return (
    <PersonalizedInviteProvider
      inviteData={adaptedData}
      loading={loading}
      error={error}
    >
      <FacialRegistrationComponent />
    </PersonalizedInviteProvider>
  );
};

FacialRegistrationContainer.propTypes = {};

export default FacialRegistrationContainer;
